import React from 'react'

export default class IconsMainNavResell extends React.Component {
    render() {
        let className = 'icons-icon'

        return (
            <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
                className={className}
                style={this.props.style}
            >
                <path
                    d='M13.3333 4H2.66665C1.93027 4 1.33331 4.59695 1.33331 5.33333V10.6667C1.33331 11.403 1.93027 12 2.66665 12H13.3333C14.0697 12 14.6666 11.403 14.6666 10.6667V5.33333C14.6666 4.59695 14.0697 4 13.3333 4Z'
                    stroke='#646464'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M8.00002 9.33329C8.7364 9.33329 9.33335 8.73634 9.33335 7.99996C9.33335 7.26358 8.7364 6.66663 8.00002 6.66663C7.26364 6.66663 6.66669 7.26358 6.66669 7.99996C6.66669 8.73634 7.26364 9.33329 8.00002 9.33329Z'
                    stroke='#646464'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M4 8H4.00667M12 8H12.0067'
                    stroke='#646464'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </svg>
        )
    }
}
